import { Component, Input } from '@angular/core';
import { PatientReminderModel } from '../../../core/api/models';
import { SupervisorApiService } from '../../../core/api/services';
import { SupervisorHelperService } from '../../supervisor.helper.service';
import { AlertService } from '../../../shared/services/alert.service';
import { Utils } from '../../../core/utils';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-reminder',
  templateUrl: './reminder.component.html',
  styleUrl: '../../supervisor-main.component.css',
  standalone: false,
})
export class ReminderComponent {
  @Input() reminder: PatientReminderModel | undefined;

  constructor(
    private supervisorApiService: SupervisorApiService,
    private supervisorHelperService: SupervisorHelperService,
    private alertService: AlertService
  ) {}

  isCollapsed = true;

  toggleCollapsed() {
    this.isCollapsed = !this.isCollapsed;
  }

  getTime(date: any){
        if (!date) return null;
        return formatDate(date, 'HH:mm aa', 'en-US');
  }

  getDays(days: string | null | undefined) : string {
    var string = "";
    if (days == null || days == ""){
      string = "";
    }
    else{
      var arr = days.split(",");
      var shortArr = [];
      for (var day of arr){
        shortArr.push(day.slice(0,3));
      }
      string = shortArr.join(", ").slice(0, -2);
    }
    if(this.reminder?.Type == "Monthly"){
      var md = this.getMonthData(this.reminder?.WeekOfMonth);
      string += md;
    }
    return string;
  }

  getMonthData(week: number | null | undefined) : string {
    if(week == null || week == 0){
      return "";
    }
    else{
      if (week == 1){
        return " on 1st week of each month";
      }
      else if (week == 2){
        return " on 2nd week of each month";
      }
      else if (week == 3){
        return " on 3rd week of each month";
      }
      else if (week == 4) {
        return " on 4th week of each month";
      }
      else{
        return "";
      }
    }
  }

  editReminder() {
    console.log('editReminder clicked!');
    this.supervisorHelperService.addReminderButtonClicked(
      this.reminder ?? null
    );
  }

  restoreReminder() {
    if(this.reminder?.ID != null){
      this.supervisorApiService
      .RestorePatientReminder({ patientReminderID: this.reminder?.ID ?? 0 })
      .subscribe(() => {
        this.alertService.success('reminder restored');
        this.supervisorHelperService.triggerUpdateSignal();
      });
    }
  }

  deleteReminder() {
    console.log('deleteReminder clicked!');

    this.alertService
      .confirm(
        'Delete Reminder',
        'Are you sure you want to delete this reminder?'
      )
      .subscribe((result) => {
        if (result) {
          this.deleteReminderConfirmed();
        }
      });
  }

  deleteReminderConfirmed() {
    if (this.reminder?.ID != null) {
      this.supervisorApiService
        .DeletePatientReminder({ patientReminderID: this.reminder.ID })
        .subscribe(
          () => {
            this.alertService.success('Reminder deleted successfully');
            this.supervisorHelperService.triggerUpdateSignal();
          },
          (error) => {
            this.alertService.error(
              Utils.getErrorMessageFromErrorResponse(error)
            );
          }
        );
    }
  }
}
